(function () {
  'use strict';

  angular.module('eclipseApp.core')
    .filter('dateFormatForBillingCycleStart', ['$filter', function dateFormatForBillingCycleStart($filter) {
      return function (date, lang) {
        if (!date || date === null || date === '') {
          return '';
        }
        var translatedDate;

        var monthsEn = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var monthsFr = [
          "janv.",
          "f\u00e9vr.",
          "mars.",
          "avr.",
          "mai.",
          "juin.",
          "juil.",
          "ao\u00fbt.",
          "sept.",
          "oct.",
          "nov.",
          "d\u00e9c."
        ];

        var monthName = date.substring(0, 3);
        var day = date.substring(4, 6);

        var index = monthsEn.indexOf(monthName);
        if(index!== -1 && day !== '' && day){

          if (lang === 'fr') {
            translatedDate = day +' '+ monthsFr[index];
          }
          else {
            translatedDate = monthsEn[index] +'. '+ day;
          }

          return ' (' + translatedDate + ') ';

        }
        else{
          return '';
        }


      }
    }])
    .controller('usageDetailsRealtimeCtrl', ['$translate',
      '$q',
      '$filter',
      '$scope',
      '$state',
      '$rootScope',
      '$http',
      '$stateParams',
      'uteModal',
      'usageService',
      'uteLocale',
      'commonService',
      'uteEndpoint',
      'lostStolenDeviceService',
      'env',
      'httpService',
      'permissionsService',
      'pricePlanInitiation',
      'dtmService',
      'dtmServiceConstants',
      'dataLayerService',
      '$window',
      'brtSwitchCMS',
      'dataExtraAPIService',
      'manageDataService',
      function ($translate,
                $q,
                $filter,
                $scope,
                $state,
                $rootScope,
                $http,
                $stateParams,
                uteModal,
                usageService,
                uteLocale,
                commonService,
                uteEndpoint,
                lostStolenDeviceService,
                env,
                httpService,
                permissionsService,
                pricePlanInitiation,
                dtmService,
                dtmServiceConstants,
                dataLayerService,
                $window,
                brtSwitchCMS,
                dataExtraAPIService,
                manageDataService) {


        function trackBannerInfoAnalytics(analyticsInfo){

          var AnalyticsDataLayer = {
            'account': dataLayerService.getAccountInfo(),
            'interaction':{
              'type' :'open',
              'name' : analyticsInfo
            },
            'events': {
              'interaction':true
            }
          }

          dataLayerService.trackDataLayer(AnalyticsDataLayer);

        }



        console.log('billingCycleInfo, newCycleStart : ', $scope.billingCycleInfo, $scope.newCycleStart);
        console.log('realTimeUsageData recieved in usageDetails new controller', $scope.realTimeUsageData);

        console.log('ctn, accountNumber: ', $scope.ctn, $scope.ban);

        $scope.dial_heading_plan_firstname = '';

        var x_session_token = $window.localStorage.getItem("x_session_token");
        var janrainCaptureProfileData = $window.localStorage.getItem("easyLoginDataJanrain");
        var profileId = janrainCaptureProfileData !== null ? janrainCaptureProfileData.uuid : '';
        var userId = janrainCaptureProfileData !== null ? JSON.parse(janrainCaptureProfileData).userID : '';

        $scope.selectedBan = $scope.ban;
        $scope.selectedCTN = $scope.ctn;
        $scope.language = uteLocale.language;

        $scope.customerName = $rootScope.userInfo.firstName;
        $scope.refreshLoader = false;

        function textTalkUsageDetails() {
          return $http({
            method: 'POST',
            url: env.genesisApiURL + 'uep/v1/textTalkUsageDetails',
            headers: {
              'x-session-token': x_session_token,
              'x-app-id': 'Fido',
              'userId': userId,
              'profileId': profileId
            },
            data: {
              ctn: $scope.ctn,
              accountNumber: $scope.ban,
              language: uteLocale.language,
              region: uteLocale.province
            },
            withCredentials: false
          });
        }

        function getAccountId() {

          var profileIdForAccountIdCall  = janrainCaptureProfileData !== null ? JSON.parse(janrainCaptureProfileData).uuid : '';

          return $http({
            method: 'GET',
            url: env.genesisApiURL + 'billing-account-svc/v1/accounts?brand=Fido&profileId=' + profileIdForAccountIdCall ,
            headers: {
              'x-session-token': x_session_token,
              'x-app-id': 'Fido',
              'If-Modified-Since': null
            },
            transformRequest: function (data, headers) {
              delete headers()['If-Modified-Since'];
            },
            withCredentials: false
          });

        }

        function getbillingInfo(accountId) {
          return $http({
            method: 'GET',
            url: env.genesisApiURL + 'billing-account-svc/v1/accounts/' + accountId + '/billingInfo',
            headers: {
              'x-session-token': x_session_token,
              'x-app-id': 'Fido',
              'userId': userId,
              'profileId': profileId,
              'If-Modified-Since': null
            },
            transformRequest: function (data, headers) {
              delete headers()['If-Modified-Since'];
            },
            withCredentials: false
          });
        }

        function dataExtras() {
          return $http({
            method: 'POST',
            url: env.genesisApiURL + 'uep/v1/dataExtras',
            headers: {
              'x-session-token': x_session_token,
              'x-app-id': 'Fido',
              'userId': userId,
              'profileId': profileId
            },
            data: {
              ctn: $scope.ctn,
              accountNumber: $scope.ban,
              language: uteLocale.language,
              region: uteLocale.province
            },
            withCredentials: false
          });
        }

        function parseTalkAndText(res) {
          var data = res.data;
          console.log('API textTalkUsageDetails response :', data);
          if (!(data && data.content && data.content.talk &&
              Array.isArray(data.content.talk) && data.content.talk[0]
              && data.content.talk[0].wirelessUsageSummaryInfoList &&
              Array.isArray(data.content.text) && data.content.text[0] &&
              data.content.text[0].wirelessUsageSummaryInfoList)) {
            console.log('talk and text data is not valid: ', data);
            $scope.switchToLegacy();
          }
          console.log('textTalkUsageDetails data is valid');

          $scope.talkData = data.content.talk[0].wirelessUsageSummaryInfoList;
          $scope.textData = data.content.text[0].wirelessUsageSummaryInfoList;


        }

        function parseDataExtras(res) {
          var data = res.data;
          console.log('API dataExtras response :', data);

          if (data && data.content && data.content.planName) {

            $scope.planName = data.content.planName;
            //$scope.$broadcast('dataExtraFetchedForDial', data.content);

            dataExtraAPIService.setDataExtraList(data.content.dataExtrasList);
            dataExtraAPIService.setOverageRate(data.content.overageRate);
            dataExtraAPIService.setPlanName(data.content.planName);
            dataExtraAPIService.setPlanNameFR(data.content.planNameFr);

            if (_.has(data.content, 'planSize') && _.has(data.content, 'planSizeUOM')) {
              var planDetails = data.content.planSize.toString().concat(' ').concat(uteLocale.language.toLowerCase() === 'en' ? data.content.planSizeUOM.displayNameEn : data.content.planSizeUOM.displayNameFr);
              dataExtraAPIService.setPlanSize(planDetails);
            }

            //renderPlanName();
          }
        }

        function renderPlanName() {
          if ($scope.customerName) {
            if($scope.planName){
              $translate('wireless.label.heading_plan_of').then(function(text)
              {
                if (uteLocale.language === 'en') {
                  $scope.dial_heading_plan_firstname = $scope.customerName.toUpperCase()
                    + text
                    + $scope.planName.toUpperCase() ;
                }

                else {
                  $scope.dial_heading_plan_firstname = text
                    + $scope.customerName.toUpperCase() + ' : '
                    + $scope.planName.toUpperCase() ;
                }
              });
            }
            else{
              $scope.dial_heading_plan_firstname = $scope.customerName.toUpperCase();
            }
          }

        }

        function setBannerInfo(code) {

          code = parseInt(code);
          var analyticsInfo = '' ;


          switch (code) {
            case 0:
              $scope.showBanner = false;
              analyticsInfo ='wireless real time - default';
              break;
            case 1:
              $scope.banner_path = "bk_next_bc";
              $scope.banner_class = "banner-warning";
              $scope.showBanner = true;
              analyticsInfo ='wireless real time - end cycle delay';
              break;
            case 2:
              $scope.banner_path = "rt_after_12h";
              $scope.banner_class = "banner-error";
              $scope.showBanner = true;
              analyticsInfo ='wireless real time - 12 hour delay';
              break;
            case 3:
              $scope.banner_path = "rt_after_12h";
              $scope.banner_class = "banner-error";
              $scope.showBanner = true;
              analyticsInfo ='wireless real time - 12 hour delay';
              break;
            case 4:
              $scope.banner_path = "bk_after_48h";
              $scope.banner_class = "banner-warning";
              $scope.showBanner = true;
              analyticsInfo ='wireless real time - 48 hour delay';
              break;
            case 5:
              $scope.banner_path = "bk_next_bc";
              $scope.banner_class = "banner-warning";
              $scope.showBanner = true;
              analyticsInfo ='wireless real time - end cycle delay';
              break;
            default:

          }

        trackBannerInfoAnalytics(analyticsInfo);

        }

        $scope.switchToLegacy = function () {
          $state.go('myAccount.wireless', {
            'accountNumber': $scope.selectedBan,
            'subscriberNo': $scope.selectedCTN,
            'legacy': true
          });
        };

        $scope.refresh = function() {
          $scope.refreshLoader = true;
          $scope.refreshDial();
        };

        $scope.init = function() {
          $scope.textTalkEligible = true;
          $scope.dataEligible = true;
          $scope.textTalkReady = false;
          setBannerInfo($scope.realTimeUsageData.statusCode);
          getAccountId()
            .then(function (res) {
              if(res.data.content.length > 0){

              var accountIdForBAN = $filter('filter')(res.data.content , {number: $scope.ban.toString() }, true)[0];

                if(!accountIdForBAN){
                  accountIdForBAN = res.data.content[0];
                }
                console.log(accountIdForBAN);
                return getbillingInfo(accountIdForBAN.id);
              }
              else{
                throw new Error('account id not found from billing-account-svc API');
              }
            })
            .then(function (res) {
              var monthDate = res.data.content.nextBillCycleStartDate.substring(0, 9);
              $scope.newCycleStart = monthDate;
              $scope.billingCycleInfo = res.data.content.billingCycleDay;
              if(res && res.data && res.data.content) {
                manageDataService.setBillingInfo(res.data.content);
                manageDataService.setAccountId(res.data.content.accountId);
              }
            }, function (error) {
              console.log(error);
            });
          var refreshedCTN = [];
          if ($window.localStorage.getItem('usageRefresh')) {
            refreshedCTN = JSON.parse($window.localStorage.getItem('usageRefresh'));
          }
          if (permissionsService.permissionDetail.isFidoDisableAllUsage && !(_.indexOf(refreshedCTN, $rootScope.userInfo.selectedSubscriberNo) > -1)) {
            $scope.dataEligible = false;
          }
          if ((!permissionsService.permissionDetail.isFidoDisplayDataUsage && !permissionsService.permissionDetail.isFidoDisableAllUsage)
              || _.indexOf(refreshedCTN, $rootScope.userInfo.selectedSubscriberNo) > -1) {
            textTalkUsageDetails()
              .then(function (data) {
                parseTalkAndText(data);
                $scope.textTalkReady = true;
              }, function (error) {
                $scope.textTalkReady = false;
                $scope.switchToLegacy();
              });
          }
          else {
            $scope.textTalkReady = true;
            $scope.talkData = [];
            $scope.textData = [];
            $scope.textTalkEligible = false;
          }
          dataExtras()
            .then(function (data) {
              parseDataExtras(data);
              renderPlanName();
              $scope.refreshLoader = false;
            }, function (error) {
              console.log('Error calling Data Extra API', error);
              renderPlanName();
              $scope.refreshLoader = false;
            });
        };

        $scope.$watch('dialRefreshed', function(newVal, oldVal) {
          if (newVal) {
            $scope.init();
          }
        });

        $scope.init();

      }


    ]);
})();
